module.exports = __webpack_public_path__ + "static/media/img43.6d2bd106.jpeg";